<template>
	<div v-if="user">
		<h3>Password</h3>

		<form
			method='POST'
			@submit.prevent='changePassword()'
		>
			<div>
				<label>
					Nuova password (almeno 8 caratteri)<br>
					<input
						type="text"
						v-model="password"
						class="form-control"
					>
				</label>
			</div>

			<div>
				<label>
					Ripeti password<br>
					<input
						type="text"
						v-model="passwordRe"
						class="form-control"
					>
				</label>
			</div>

			<flash
				:flash="flash"
				:state="state"
			>
			</flash>

			<CTA
				:content="`Aggiorna`"
				type="submit"
			/>
		</form>
	</div>
</template>

<script>

import { UserApi } from '../../api/UserApi'
import Flash from '../../components/Parts/Flash'

export default {

	props: {
		user: {
			type: Object,
			default () {
				return null
			}
		}
	},

	components: {
		'flash': Flash
	},

	data () {
		return {
			password: null,
			passwordRe: null,

			flash: null,
			state: null
		}
	},

	methods: {
		changePassword () {
			this.flash = null

			var params = {
				password: this.password,
				password_repeat: this.passwordRe
			}

			if (this.password !== this.passwordRe) {
				this.flash = 'Il campo password non coincide con ripeti password'
				this.state = 'error'
				return
			}

			var um = new UserApi()
			um.changePassword(params).then(response => {
				this.flash = 'Password cambiata con successo'
				this.state = 'success'

				this.password = null
				this.passwordRe = null
			}).catch(response => {
				this.flash = this.$t('api.' + response.body.errors[0].code.toLowerCase())
				this.state = 'error'
			})
		},

		toggleLabel (name) {
			this[name] = !this[name]
		}
	}
}

</script>

<style scoped>
label {
	width: 100%;
	max-width: 300px;
}
</style>
